import React, { useState } from 'react'
import Helmet from 'react-helmet'
import Modal from 'ui/modal'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import { Button, ButtonGroup } from 'reactstrap'
import MomentLocaleUtils from 'react-day-picker/moment'
import 'moment/locale/es'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const DateRangePicker = ({ from, to, setFrom, setTo, onChange }) => {
  const [enteredTo, setEnteredTo] = useState()
  const [modal, setModal] = useState(false)
  const { i18n } = useTranslation()

  const modifiers = { start: from, end: enteredTo }
  const selectedDays = [from, { from, to: enteredTo }]

  const toggle = () => setModal(!modal)

  const isSelectingFirstDay = (from, to, day) => {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from)
    const isRangeSelected = from && to
    return !from || isBeforeFirstDay || isRangeSelected
  }

  const handleDayClick = (day) => {
    if (isSelectingFirstDay(from, to, day)) {
      setFrom(day)
      setTo(null)
      setEnteredTo(null)
    } else {
      setTo(day)
      setEnteredTo(day)
      toggle()
      onChange(from, day)
    }
  }

  const handleDayMouseEnter = (day) => {
    if (!isSelectingFirstDay(from, to, day)) {
      setEnteredTo(day)
    }
  }

  const handlePreset = (fromDate, toDate) => {
    setFrom(fromDate)
    setEnteredTo(toDate)
    setTo(toDate)
    toggle()
    onChange(fromDate, toDate)
  }

  const filteringLabel = () => {
    if (!from && !to) {
      return i18n.t('date_range_picker.select_from')
    } else if (from && !to) {
      return i18n.t('date_range_picker.select_to')
    } else if (from && to) {
      return i18n.t('date_range_picker.filtering_from_to', {
        from: from.toLocaleDateString(),
        to: to.toLocaleDateString(),
        interpolation: { escapeValue: false },
      })
    }
  }

  return (
    <>
      {/* Input group modernizado (Bootstrap 5) */}
      <div
        className="input-group mb-3"
        style={{ cursor: 'pointer' }}
        onClick={toggle}
      >
        <span className="input-group-text" id="date-addon">
          <i className="far fa-calendar-alt" />
        </span>
        <input
          type="text"
          className="form-control"
          readOnly
          value={filteringLabel()}
          style={{ cursor: 'pointer' }}
        />
      </div>

      <Modal
        isOpen={modal}
        toggle={toggle}
        title={filteringLabel()}
        width={850}
        bodyStyle={{ padding: '35px' }}
      >
        <div className="d-flex align-items-start flex-wrap">
          <div className="me-3 mb-3">
            <ButtonGroup vertical>
              <Button className="text-white" color="primary" style={{ padding: '9px 10px' }}>
                {i18n.t('date_range_picker.custom_interval')}
              </Button>
              <Button
                className="text-white"
                color="primary"
                style={{ padding: '9px 30px' }}
                onClick={() =>
                  handlePreset(moment().startOf('day').toDate(), moment().endOf('day').toDate())
                }
              >
                {i18n.t('date_range_picker.today')}
              </Button>
              <Button
                className="text-white"
                color="primary"
                style={{ padding: '9px 30px' }}
                onClick={() =>
                  handlePreset(
                    moment().subtract(1, 'day').startOf('day').toDate(),
                    moment().subtract(1, 'day').endOf('day').toDate()
                  )
                }
              >
                {i18n.t('date_range_picker.yesterday')}
              </Button>
              <Button
                className="text-white"
                color="primary"
                style={{ padding: '9px 30px' }}
                onClick={() =>
                  handlePreset(moment().startOf('week').toDate(), moment().endOf('week').toDate())
                }
              >
                {i18n.t('date_range_picker.this_week')}
              </Button>
              <Button
                className="text-white"
                color="primary"
                style={{ padding: '9px 30px' }}
                onClick={() =>
                  handlePreset(moment().startOf('month').toDate(), moment().endOf('month').toDate())
                }
              >
                {i18n.t('date_range_picker.this_month')}
              </Button>
              <Button
                className="text-white"
                color="primary"
                style={{ padding: '9px 30px' }}
                onClick={() =>
                  handlePreset(
                    moment().subtract(1, 'month').startOf('month').toDate(),
                    moment().subtract(1, 'month').endOf('month').toDate()
                  )
                }
              >
                {i18n.t('date_range_picker.last_month')}
              </Button>
            </ButtonGroup>
          </div>

          <div>
            <DayPicker
              className="Range"
              numberOfMonths={2}
              month={from}
              selectedDays={selectedDays}
              modifiers={modifiers}
              onDayClick={handleDayClick}
              onDayMouseEnter={handleDayMouseEnter}
              localeUtils={MomentLocaleUtils}
              locale="es"
            />

            <Helmet>
              <style>{`
                .DayPicker-wrapper {
                  padding-bottom: 0;
                }

                .DayPicker-Month {
                  margin: 0 1em;
                }

                .Range .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                  background-color: #f0f8ff !important;
                  color: #4a90e2;
                }

                .Range .DayPicker-Day {
                  border-radius: 0 !important;
                }
              `}</style>
            </Helmet>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default DateRangePicker
